var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2381 3.11913V10.9765H10.5238V12.2861H1.2381C0 12.2861 0 10.9765 0 10.9765V3.11913H1.2381ZM11.7619 1.80956V8.35738H3.71429V1.80956H11.7619ZM11.9476 0.5H3.52857C2.94667 0.5 2.47619 0.958347 2.47619 1.51491V8.65203C2.47619 9.21515 2.94667 9.66694 3.52857 9.66694H11.9476C12.5295 9.66694 13 9.21515 13 8.65203V1.51491C13 0.958347 12.5295 0.5 11.9476 0.5ZM4.33333 2.46435H6.19048V5.73825H4.33333V2.46435ZM11.1429 7.7026H4.33333V6.39304H11.1429V7.7026ZM11.1429 3.77391H7.42857V2.46435H11.1429V3.77391ZM11.1429 5.73825H7.42857V4.42869H11.1429V5.73825Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.d9bf62b4.svg";
export { ForwardRef as ReactComponent };